import React, { useEffect, useState } from "react";
import { GetAllNotifications } from './API';

export default function NotificationPage(props) {
    const [data, setData] = useState({});
    useEffect(() => {
         GetAllNotifications(20).then(data => {
            data = data.filter( x => x.serial == props.match.params.id)[0]
            setData( data );
        });
    },[props.match.params.id]  );
  return (
          <div>
      <div class="card">
        <div class="card-block">
          <h4 class="card-title m-t-0">
          <h2 class="media-heading"> {data.stitle}</h2>

        </h4>
          <p class="card-text">
          {data.smess}
          </p>
        </div>
      </div>
      
          </div>

  );
}



// WEBPACK FOOTER //
// ./src/pages/Notifications/NotificationPage.js